import React from "react";

export default function renderIcon({
  width = 12.308,
  height = 10.177,
  color = "#897143",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12.308 10.177"
    >
      <g
        id="Group_784"
        data-name="Group 784"
        transform="translate(11.891 0.276) rotate(90)"
      >
        <line
          id="Line_214"
          data-name="Line 214"
          x2="9.625"
          y2="6.375"
          fill="none"
          stroke={color}
          strokeWidth="1"
        />
        <line
          id="Line_215"
          data-name="Line 215"
          y1="6.375"
          x2="9.625"
          transform="translate(0 5.1)"
          fill="none"
          stroke={color}
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}
